<template>
  <a-card :bordered="false">
    <div style="width: 100%; text-align: center;">
      <h3>知识库表单</h3>
    </div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="问卷中文名称">
              <j-input placeholder="请输入名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
             <a-form-item label="模块">
              <a-select placeholder="请选择模块" v-model="queryParam.modelType" showSearch allow-clear  :filterOption="filterOption">
                <a-select-option :value="item.id" v-for="(item, index) in modelTye" :key="index">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

            <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-checkbox :checked="wholeDb" style="margin-left: 8px" @change="wholeDb = !wholeDb">
                      全库
                  </a-checkbox>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dateSource2"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="statusAction" slot-scope="text, record">          
          <span v-if="(record.status&15)==15">已完成 </span>
          <span v-else>
            <span>已新增 </span>
            <span v-if="(record.status&2)==2">已导入 </span>
            <span v-if="(record.status&8)==8">已附件 </span>
            <span v-if="(record.status&4)==4">已分类 </span>
          </span>        
          
          <span v-if="(record.status&16)==16">已审核 </span>
          <span v-if="(record.status&32)==32">已上线 </span>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="addFormListHandle(record)">添加</a>
        </span>

      </a-table>
    </div>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { getAction, postAction, deleteAction } from '@api/manage';
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  
  export default {
    name: "CsimSchemaAttributeUnSelectFormList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
    },
    props:{
      existIdList:{
        type:Array,
        default:()=>{
          return []
        }
      },
      model: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        modelData: {},
        description: '项目受试者自定义配置管理页面',
        // 表头
        columns: [
          {
            title: '问卷中文名称',
            align:"center",
            dataIndex: 'name',
            scopedSlots: { customRender: 'formName' },
          },
          {
            title: '创建者',
            align:"center",
            dataIndex: 'createName'
          },
          {
            title: '提交时间',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: '更新者',
            align:"center",
            dataIndex: 'updateName'
          },
          {
            title: '状态',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusAction' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/tempconfig/tempConfigForm/list",
        },
        disableMixinCreated:true,
        viewVisible:false,
        current:{},
        modelTye:[
          {id:1,name:'通用'},
          {id:2,name:'专病'},
        ],
        wholeDb: false,
      }
    },
    computed: {
      dateSource2(){
        return this.dataSource.filter(item=> this.existIdList.indexOf(item.id)===-1)
      }
    },
    mounted(){
      this.baseQueryParam = {}
    },
    methods: {
      handleSetSchema(record) {
        this.modelData = record;
        this.baseQueryParam.schemeId = this.modelData.id
        this.baseQueryParam.deptId = this.wholeDb ? '' : this.modelData.departmentId
        this.baseQueryParam.submajorId = this.wholeDb ? '' : this.modelData.subSpecialtyId
        this.baseQueryParam.diseaseId = this.wholeDb ? '' : this.modelData.diseaseTypeId
        this.loadData();
      },

      formItemSetHandle(record){
        this.$refs.formItemSet.view(record)
      },
      onViewClose(){
        this.viewVisible = false
      },
      addFormListHandle(record){
        postAction('/scheme/form/add?formId=' + record.id + '&schemeId=' + this.model.id, {}).then(res=>{
          if(res.success){
            this.$message.success(res.message)

            this.$emit('formListRefresh')
          } else {
            this.$message.error(res.message)
          }
        }).finally(()=>{
          // todo
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      setQueryParam() {
        this.getModelData();
        this.queryParam.deptId = this.wholeDb ? '' : this.modelData.departmentId
        this.queryParam.submajorId = this.wholeDb ? '' : this.modelData.subSpecialtyId
        this.queryParam.diseaseId = this.wholeDb ? '' : this.modelData.diseaseId
      },
      searchQuery() {
        this.setQueryParam()
        this.loadData()
      },
      wholeDBChange() {
        this.setQueryParam()
        this.wholeDb = !this.wholeDb;
      },
      getModelData() {
        this.modelData = this.$emit('getModelData');
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  /deep/ .ant-card-body {
    padding: 0px 24px 0 24px;
  }
</style>